import {z} from 'zod';
import describeIdFormat from 'common/src/modules/campaigns/copilot/skills/campaignSetupSkill/idHelpers/utils/describeIdFormat';
import {IdPrefix} from 'common/src/modules/campaigns/copilot/skills/campaignSetupSkill/idHelpers/idHelpers.enums';

const baseCardSchema = z.object({
  cardId: z.number().describe('The ID of the card'),
  name: z.string().describe('The name of the card'),
  description: z.string().describe('A brief description of what this card does'),
});

const addOrUpdateCardInputSchema = z.object({
  prompt: z.string().describe('The prompt to use for the card'),
  cardId: z
    .string()
    .optional()
    .nullable()
    .describe(
      `${describeIdFormat(IdPrefix.Card)} Only when updating an existing card; when creating a new card, omit this field.`,
    ),
});

export {addOrUpdateCardInputSchema, baseCardSchema};
